import { ConfirmationCodeNeededDetails } from 'utils/constants/swarm/backend-status-codes';
import { TSwarmGenericResponse } from 'interfaces/generic';

export const checkIsConfirmationCodeNeeded = (
  data: TSwarmGenericResponse
): boolean => {
  return (
    ((data.result === ConfirmationCodeNeededDetails.code ||
      data.result === ConfirmationCodeNeededDetails.alternateCode) &&
      data.result_text === ConfirmationCodeNeededDetails.key) ||
    (!!data.details &&
      typeof data.details === 'object' &&
      'Key' in data.details &&
      data.status === ConfirmationCodeNeededDetails.code &&
      data?.details?.Key === ConfirmationCodeNeededDetails.key)
  );
};
